import {useEffect} from 'react'
import Navbar from './Navbar'
import { Link } from 'react-router-dom'
import { FaUser } from "react-icons/fa";
import "./RegistrationChoice.css"
import { FaBuilding } from "react-icons/fa";

const LoginChoice = () => {
    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])
  return (
    <div>
    <Navbar />
    <div className='registration-container'>
    <div className='registration-choice-container'>
    <Link to="/login">
        <FaUser className='registration-icon' />
        <div className='title-container'>
          <h2 className='registration-choice-title'>Uživatelské přihlášení</h2>
        </div>
        </Link>
      </div>
      <div className='registration-choice-container'>
      <Link to="/business/login">
        <FaBuilding className='registration-icon'/>
        <div className='title-container'>
          <h2 className='registration-choice-title'>Firemní přihlášení</h2>
        </div>
        </Link>
      </div>
    </div>
    </div>
  )
}

export default LoginChoice